var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03827 11.0847C3.16499 11.0847 4.07572 10.1722 4.07572 9.04644C4.07572 7.921 3.16499 7.00813 2.03827 7.00813C0.912485 7.00809 0 7.921 0 9.04644C0 10.1722 0.912485 11.0847 2.03827 11.0847Z",
    fill: "#5E5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03638 11.7799C0.940423 11.7799 0.0458984 12.6685 0.0458984 13.77V16.2445H2.40385L3.92529 13.1366C3.66456 12.3437 2.91982 11.7799 2.03638 11.7799Z",
    fill: "#5E5E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37262 7.18779C6.38153 7.18779 7.19798 6.37095 7.19798 5.36162C7.19798 4.354 6.38153 3.53587 5.37262 3.53587C4.36414 3.53587 3.54688 4.354 3.54688 5.36162C3.54688 6.37095 4.36418 7.18779 5.37262 7.18779Z",
    fill: "#5E5E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58496 11.418V11.8115H4.57423L6.38378 8.12373C6.09657 7.92143 5.75046 7.81006 5.37272 7.81006C5.11749 7.81006 4.87256 7.86295 4.6545 7.95899C4.79277 8.2944 4.87256 8.66101 4.87256 9.04468C4.87256 10.04 4.36171 10.9123 3.58496 11.418Z",
    fill: "#5E5E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7847 3.65192C11.7936 3.65192 12.6105 2.83508 12.6105 1.82574C12.6105 0.818126 11.7936 0 10.7847 0C9.77625 0 8.95898 0.818126 8.95898 1.82574C8.95898 2.83508 9.77625 3.65192 10.7847 3.65192Z",
    fill: "#5E5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7846 4.27286C9.79868 4.27286 8.99805 5.07268 8.99805 6.0598V6.83436H12.571V6.0598C12.5711 5.07268 11.7717 4.27286 10.7846 4.27286Z",
    fill: "#5E5E5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35449 17.647V17.2566L7.88046 8.02107H14.1191L18.6451 17.2566V17.647H3.35449Z",
    stroke: "#5E5E5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9613 11.0847C21.0871 11.0847 21.9996 10.1722 21.9996 9.04644C21.9996 7.921 21.0871 7.00813 19.9613 7.00813C18.8346 7.00813 17.9238 7.92105 17.9238 9.04644C17.9238 10.1722 18.8346 11.0847 19.9613 11.0847Z",
    fill: "#5E5E5E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9632 11.7799C19.0797 11.7799 18.335 12.3437 18.0742 13.1366L19.5957 16.2445H21.9537V13.77C21.9537 12.6685 21.0591 11.7799 19.9632 11.7799Z",
    fill: "#5E5E5E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6271 7.18779C17.6356 7.18779 18.4529 6.37095 18.4529 5.36162C18.4529 4.354 17.6356 3.53587 16.6271 3.53587C15.6182 3.53587 14.8018 4.354 14.8018 5.36162C14.8018 6.37095 15.6182 7.18779 16.6271 7.18779Z",
    fill: "#5E5E5E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6272 7.81006C16.2496 7.81006 15.9035 7.92143 15.6162 8.12373L17.4258 11.8115H18.4151V11.418C17.6383 10.9123 17.1275 10.04 17.1275 9.04468C17.1275 8.66101 17.2073 8.2944 17.3455 7.95899C17.1274 7.86291 16.8825 7.81006 16.6272 7.81006Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakout);
export default __webpack_public_path__ + "static/media/breakout.7404ded25f2bd003a9446551f72bcb4f.svg";
export { ForwardRef as ReactComponent };